import {api} from 'api/setup';
import {IProductByNameRequest, IProductByNameResponse, IProductsRequest, IProductsResponse} from 'types';
import {getLocaleFromUrl} from 'utils/helpers';

export const getProducts = (params: IProductsRequest): Promise<IProductsResponse> => {
  return api.get(`/products`, {
    params,
  });
};

export const getProductByName = (
  {slug}: IProductByNameRequest,
  locale: string = getLocaleFromUrl(),
): Promise<IProductByNameResponse> => {
  return api.get(`/products/${slug}`, {
    headers: {['Accept-Language']: locale},
  });
};
